export default "__VITE_ASSET__DItrhCYN__"